export const SUPPORTED_UPLOAD_FORMATS = {
  '.pdf': { name: 'PDF Document', icon: '📄', color: 'text-red-600' },
  '.docx': { name: 'Word Document', icon: '📝', color: 'text-blue-600' },
  '.pptx': { name: 'PowerPoint Presentation', icon: '📊', color: 'text-orange-600' },
  '.txt': { name: 'Text File', icon: '📃', color: 'text-gray-600' },
  '.md': { name: 'Markdown', icon: '📋', color: 'text-purple-600' },
  '.xlsx': { name: 'Excel Spreadsheet', icon: '📊', color: 'text-green-600' },
  '.csv': { name: 'CSV File', icon: '📈', color: 'text-teal-600' },
  '.png': { name: 'PNG Image', icon: '🖼️', color: 'text-cyan-600' },
  '.jpg': { name: 'JPEG Image', icon: '🖼️', color: 'text-cyan-600' },
  '.jpeg': { name: 'JPEG Image', icon: '🖼️', color: 'text-cyan-600' },
  '.tif': { name: 'TIFF Image', icon: '🖼️', color: 'text-cyan-600' },
  '.tiff': { name: 'TIFF Image', icon: '🖼️', color: 'text-cyan-600' },
  '.bmp': { name: 'Bitmap Image', icon: '🖼️', color: 'text-cyan-600' },
  '.webp': { name: 'WebP Image', icon: '🖼️', color: 'text-cyan-600' },
};

export const SUPPORTED_UPLOAD_ACCEPT = Object.keys(SUPPORTED_UPLOAD_FORMATS).join(',');
